export const isLibraryLoadedForId = (state, libraryId) => {
	const loadedForLibraryId = state.libraryProperties?.id ?? null;

	if (loadedForLibraryId === null) { return false; }
	if (libraryId === null || libraryId === undefined) { return false; }

	return String(loadedForLibraryId) === String(libraryId);
};
